import GeoJsonLayer from 'src/services/geoJson/GeoJsonLayer';
import ActivityDetailsVehicleSource from '../sources/ActivityDetailsVehicleSource';

export default class ActivityDetailsVehicleLayer extends GeoJsonLayer {
  /** @type {string} */
  static id = 'activity-details-vehicle-layer';

  getConfig() {
    /** @type {import('mapbox-gl').Layer} */
    return Object.freeze({
      type: 'symbol',
      id: this.getId(),
      source: ActivityDetailsVehicleSource.id,
      layout: {
        'text-optional': true,
        'text-size': ['interpolate', ['linear'], ['zoom'], 4.9, 0, 5, 10, 16, 13],
        'text-radial-offset': ['interpolate', ['linear'], ['zoom'], 5, 0.5, 15, 1.2],
        'text-variable-anchor': ['bottom', 'top'],
        'icon-image': 'location_on',
        'symbol-avoid-edges': true,
        'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Regular'],
        'icon-size': ['interpolate', ['linear'], ['zoom'], 4.9, 0, 5, 0.1, 12, 0.7, 15, 1],
        'text-anchor': 'bottom',
        'text-field': '{name}',
        'icon-padding': 0,
        'icon-ignore-placement': true,
      },
      paint: {
        'text-halo-color': '#ffffff',
        'text-halo-width': 1,
        'text-color': '#000000',
      },
    });
  }
}
